import { render } from "./PatientCare.vue?vue&type=template&id=73c83b3e&scoped=true"
import script from "./PatientCare.vue?vue&type=script&lang=js"
export * from "./PatientCare.vue?vue&type=script&lang=js"

import "./PatientCare.vue?vue&type=style&index=0&id=73c83b3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c83b3e"]])

export default __exports__